module.exports = __webpack_public_path__ + "static/13-BEL-MANDARINE.6ff1ea71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/13-BEL-MANDARINE.png
// module id = 608
// module chunks = 35783957827783